module.exports = __webpack_public_path__ + "static/logo-short-82116d660dfc7ebd4a11c4c4c737e440.png";